import React, { useState, useEffect } from "react";

function RtPrice(props) {
	const { sym } = props;

	const symbol = `${sym?.toLowerCase()}usdt`;

	// console.log(symbol);
	// symbol = "btcusdt"
	const [price, setPrice] = useState(null);

	useEffect(() => {
		const ws = new WebSocket(
			`wss://stream.binance.com:9443/ws/${symbol}@ticker`
		);

		ws.onmessage = (event) => {
			const data = JSON.parse(event.data);
			setPrice(data.c); // 'c' is the current price
		};

		return () => {
			ws.close();
		};
	}, [symbol]);

	return (
		<div>
			<h2>Real-Time {symbol.toUpperCase()} Price</h2>
			{price ? (
				<p style={{ fontSize: "2em" }}>${parseFloat(price)}</p>
			) : (
				<p>Loading...</p>
			)}
		</div>
	);
}

export default RtPrice;
